export function isMobile() {
    return window.innerWidth < 1024;
}
